module.exports = __webpack_public_path__ + "assets/images/card-active.svg";